export const TOGGLE_FILTER = 'TOGGLE_FILTER';

const toggleFilter = () => ({
  type: TOGGLE_FILTER,
});

export default {
  toggleFilter,
};
